import type { DeleteIndicatorsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteIndicatorsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteIndicators = createMutationHook({
  name: 'deleteIndicators',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.indicator.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ ids }),
  invalidate: (trpc) => [
    trpc.frontend.indicator.indicatorById.queryKey(),
    trpc.frontend.indicator.register.queryKey(),
    trpc.frontend.indicator.indicatorsByParentId.queryKey(),
    // COI-889: the risk and control registers' Associations column carries the
    // indicator title and count, as `useInsertIndicator` already declares.
    trpc.frontend.control.register.queryKey(),
    trpc.frontend.risk.register.queryKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  mapResponse: (_result, ids: string[]): DeleteIndicatorsMutation => ({
    delete_indicator_result: {
      __typename: 'indicator_result_mutation_response',
      affected_rows: 0,
    },
    delete_indicator: {
      __typename: 'indicator_mutation_response',
      affected_rows: ids.length,
    },
  }),
  graphqlDocument: DeleteIndicatorsDocument,
  graphqlVariables: (ids: string[]) => ({ ids }),
  evictFields: ['indicator'],
});
